export default __webpack_public_path__ + "static/media/navbar-company-dark.042c99d2.svg";